import React from 'react';
import { useCan } from '@/hooks/useRbac';
import EmptyLayout from '@/components/Layout/EmptyLayout';
import { useAuthActions } from '@/utils/auth';
import { LoadingMessageCard } from '@/components/LoadingMessageCard';

export const RedirectMachinists: React.FC<{ children?: React.ReactNode }> = ({
  children,
}) => {
  const can = useCan();
  const { signOut } = useAuthActions();

  if (can('app:operario') && !can('app:manager')) {
    setTimeout(() => {
      signOut({ dontReload: true });
      window.location.href = window.location.origin.replace(
        'manager',
        // TODO sacar las URL de las apps de una env var
        window.location.origin.includes('netlify') ? 'maquinista' : 'operario'
      );
    }, 5000);
    return (
      <EmptyLayout>
        <div className="w-4/5 md:w-1/3 min-w-80 max-w-lg m-auto">
          <LoadingMessageCard
            message={
              <div className="text-center justify-items-center">
                <hr className="w-full mb-2" />
                Esta es la aplicación 'Bilderit - Manager', pero estas
                registrado en Bilderit como operario.
                <br />
                <hr className="w-full my-2" />
                Te estamos redireccionando a la aplicación 'Bilderit -
                Operario'. Si pensas que esto es un error, comunicate con
                nosotros.
              </div>
            }
          />
        </div>
      </EmptyLayout>
    );
  } else return <>{children}</>;
};
